import { useTranslation } from '@dagens/frontend-i18n';
import styled from 'styled-components';
import Typography from '@carrot-deprecated/typography';
import Theme from '@carrot-deprecated/theme';
import { MonthNumber } from 'types/Utils';
import { isBeforeMonthIndex } from 'utils/date/format';

const LetterContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: baseline;
  width: 100%;
`;

const SingleView = styled(Typography)`
  flex-grow: 1;
  margin-top: ${Theme.Spacings.xxs}px;
  text-align: center;
`;

const MultiView = styled(SingleView)`
  height: 100%;
  border-right: 1px dashed ${Theme.Colours.lightGrey};

  :last-child {
    border: none;
  }
`;

type Props = {
  multi?: boolean;
};

const CalendarMonths = ({ multi = false }: Props) => {
  const Letter = multi ? MultiView : SingleView;
  const { t } = useTranslation();
  const months = t<string[]>('calendar:months', { returnObjects: true });

  return (
    <LetterContainer>
      {months.map((month, i) => {
        return (
          <Letter
            variant="allCapsTitle"
            key={month}
            color={
              isBeforeMonthIndex(i as MonthNumber)
                ? Theme.Colours.secondary
                : Theme.Colours.black
            }
          >
            {month.slice(0, 1)}
          </Letter>
        );
      })}
    </LetterContainer>
  );
};

export default CalendarMonths;
